import { viewport } from '../../assets/js/functions'

(function($) {

  var initializeBlock = function( $block ) {
    if (viewport().width >= 1200) {
      adjustMedia()
      $( window ).bind('resize orientationchange', function() {
        adjustMedia()
      });
    }

    function adjustMedia () {
      if ($block.hasClass('block--media-with-content--pinned')) {
        if ($block.find('.grid--left').length) {
          var gridContainerWidth = $block.find('.ivwc-media').outerWidth()
          var mediaContainerWidth = $block.find('.mediaContainer').outerWidth()

          $block.find('.mediaContainer').css('margin-left', gridContainerWidth - mediaContainerWidth);
        }

        if ($block.find('.grid--right').length) {
          var gridContainerWidth = $block.find('.ivwc-media').outerWidth()
          var mediaContainerWidth = $block.find('.mediaContainer').outerWidth()

          $block.find('.mediaContainer').css('margin-right', gridContainerWidth - mediaContainerWidth);
        }
      }
    }
  }

  $( document ).ready(function() {
    $('.block--media-with-content').each(function() {
      initializeBlock( $(this) );
    })
  })

  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=media-with-content', initializeBlock );
  }

})( jQuery );